import React, { forwardRef, useImperativeHandle, useEffect, useRef, useState } from 'react';
import Button from '../Buttons/Button';
import Form from './Form';
import Input from './Input';
import Select from './Select';
import Separator from '../Display/Separator';
import { handleKeyDown } from '../Helpers';

const QuestionsForm = ({ className, lead, questionBundle, onSkip }, ref) => {
    // Form State
    const [emptyQuestions, setEmptyQuestions] = useState([]);
    const requiredQuestionCount = questionBundle.questions.reduce((acc, curr) => {
        if (curr.required) {
            acc += 1;
        }
        return acc;
    }, 0);

    const responseRefs = [];

    for (let index = 0; index < (questionBundle.questions.length || 0); index++) {
        responseRefs[index] = useRef();

    }

    const handleRequiredQuestion = (e, isRequired) => {
        if (!isRequired) {
            return;
        }
        const { id, value } = e.target;
        setEmptyQuestions(value === '' ? [...emptyQuestions, id] : emptyQuestions.filter(el => el !== id));
    };

    const renderLabel = question => {
        return question.required ? `${question.text} *` : question.text;
    };

    const getAnswers = () => {
        return questionBundle.questions.map((q, k) => {
            const response = responseRefs[k] && responseRefs[k].current.value !== '' ? responseRefs[k].current.value : undefined;
            return {
                tag: q.tag,
                text: q.text,
                response
            }
        });
    };

    const validateForm = () => {
        const invalidQuestions = questionBundle.questions.map((question, qNum) => {
            const response = !!responseRefs[qNum] ? responseRefs[qNum].current.value : '';
            if (question.required && (!response || response === '')) {
                return `question${qNum}`;
            }
        }).filter((item) => {
            return !!item;
        });
        setEmptyQuestions(invalidQuestions);
        return !invalidQuestions.length;
    };

    useImperativeHandle(ref, () => ({
        getAnswers,
        validateForm
    }));

    return (
        <>
            <Form id="clx-form__questions" className={`clx-form__contact ${className}`} onSubmit={validateForm}>
                {questionBundle.questions.map((question, i) => {
                    return question.response_format === 'select' && question.picklist && question.picklist.length > 0 ? (
                        <Select
                            key={`question${i}`}
                            id={`question${i}`}
                            label={renderLabel(question)}
                        >
                            <select
                                id={`question${i}`}
                                name={`question${i}`}
                                ref={responseRefs[i]}
                                className={emptyQuestions.includes(`question${i}`) ? 'invalid' : ''}
                                data-test-id={`clx-form__question-${i}`}
                                onBlur={e => handleRequiredQuestion(e, question.required)}
                            >
                                <option></option>
                                {question.picklist.map((item, index) => {
                                    return <option key={`answer-${index}`} value={item.value}>{item.value}</option>;
                                })}
                            </select>
                            {emptyQuestions.includes(`question${i}`) && (
                                <span className="validation">This question is required</span>
                            )}
                        </Select>
                    ) : (
                        <Input
                            key={`question${i}`}
                            id={`question${i}`}
                            label={renderLabel(question)}
                        >
                            <input
                                id={`question${i}`}
                                name={`question${i}`}
                                ref={responseRefs[i]}
                                className={emptyQuestions.includes(`question${i}`) ? 'invalid' : ''}
                                data-test-id={`clx-form__question-${i}`}
                                onBlur={e => handleRequiredQuestion(e, question.required)}
                                type="text"
                            />
                            {emptyQuestions.includes(`question${i}`) && (
                                <span className="validation">This question is required</span>
                            )}
                        </Input>
                    );
                })}
                {requiredQuestionCount === 0 && (
                    <div className="clx-privacy" style={{ textAlign: 'center' }}>
                        <Button label="Skip Questions" onClick={onSkip} onKeyDown={() => handleKeyDown(onSkip)} />
                    </div>
                )}
            </Form>
        </>
    );
};

export default forwardRef(QuestionsForm);
